import axios from "axios";
import ErrorParser from '../../services/error.parser';

const ComponentsService = {
  components: async function () {
    const requestData = {
      method: "get",
      url: "/api/components"
    };
    try {
      const response = await axios(requestData);
      return JSON.parse(response.data);
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },
  //default components, appsettings
  ndcomponents: async function () {
    const requestData = {
      method: "get",
      url: "/api/components/default"
    };
    try {
      const response = await axios(requestData);
      return JSON.parse(response.data);
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },
};

export default ComponentsService;

